var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLbank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 747 162",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u9875\\u9762-1",
    "data-name": " \\u9875\\u9762-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lbank-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": " Group "
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": " Compound Path ",
    className: "cls-1",
    d: "M78.6,16.5c-37.4,0-67.8,30.3-67.8,67.8s30.3,67.8,67.8,67.8,67.8-30.3,67.8-67.7h0c-.7-37.7-30.8-67.9-67.8-67.9h0ZM84.8,95.3c2,1.7,3.1,4.2,3.1,6.8-.1,5.1-4.2,9.1-9.2,9.2-2.6-.1-5-1.2-6.8-3.1-6.7-5.8-16.7-5.8-23.4,0l-.6.6c-1.8,1.2-3.7,2.5-6.2,2.5-2.3.1-4.6-.8-6.2-2.5l-1.2-1.2v-.6l-.6-.6c0-.6-.6-1.2-.6-1.9s-.6-1.9-.6-2.5h0c0-1.2,0-1.8.6-2.5,0-.6.6-1.2.6-1.9s.3-.6.6-.6h0v-.6c.8,0,1.2-.2,1.2-.6l.6-.6h0c2.7-3.1,4.2-7,4.3-11.1.2-4.1-1.4-8.2-4.3-11.1-1.6-2.2-2.4-4.7-2.5-7.4,0-5.1,4.2-9.1,9.2-9.2,4.9,0,8.6,4.3,8.6,9.2s-1.2,5-3.1,6.8c-5.8,6.7-5.8,16.7,0,23.4l.6.6h0c3.1,2.7,7,4.2,11.1,4.3,4.1.2,8.2-1.4,11.1-4.3,0-.6.6-.6,1.2-1.2h0c2.7-3.1,4.2-7,4.3-11.1.2-4.1-1.4-8.2-4.3-11.1-2-1.9-3.1-4.6-3.1-7.4,0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2c-.1,2.6-1.2,5-3.1,6.8-2.8,3.3-4.3,7.4-4.3,11.7.1,4.3,1.7,8.3,4.6,11.2h0ZM96.5,92.9c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2,9.2,4.1,9.2,9.2h0c.1,5-3.9,9.1-8.9,9.2h-.3ZM120.5,95.3h0c.6,1.2,1.2,1.2,1.2,1.2v.6l.6.6c0,.6.6,1.2.6,1.9s.6,1.9.6,2.5h0c0,1.2,0,1.9-.6,2.5,0,.6-.6,1.2-.6,1.9s-.3.6-.6.6h0v.6l-1.2,1.2c-1.9,1.2-3.7,2.5-6.2,2.5-2.3.1-4.6-.8-6.2-2.5l-1.2-1.2v-.7l-.6-.6c0-.6-.6-1.2-.6-1.9s-.6-1.9-.6-2.5h0c0-1.2,0-1.8.6-2.5,0-.6.6-1.2.6-1.9s.3-.6.6-.6h0v-.6l.6-.6.6-.6c2.7-3.1,4.2-7,4.3-11.1.2-4.1-1.4-8.2-4.3-11.1-1.9-1.8-3-4.2-3.1-6.8,0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2c-.1,2.6-1.2,5-3.1,6.8-2.8,3.3-4.3,7.4-4.3,11.7.2,3.8,2,7.5,4.5,10.6h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_",
    "data-name": " Path ",
    className: "cls-1",
    points: "204.9 134.8 204.9 33.1 230.8 33.1 230.8 114.4 276.3 114.4 276.3 134.8 204.9 134.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": " Path 2",
    className: "cls-1",
    points: "727.9 134.8 677.4 84.2 727.9 33.7 690.9 33.7 658.9 65.8 658.9 33.1 633 33.1 633 134.8 658.9 134.8 658.9 102.7 690.9 134.8 727.9 134.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_3",
    "data-name": " Path 3",
    className: "cls-1",
    points: "432.8 115 426.6 134.8 399.5 134.8 434.6 33.1 469.1 33.1 504.3 134.8 477.2 134.8 471 115 464.8 95.9 451.9 53.4 438.3 95.9 432.8 115"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_4",
    "data-name": " Path 4",
    className: "cls-1",
    points: "546.1 68.2 546.1 134.8 521.5 134.8 521.5 33.1 553.5 33.1 591.7 102.7 591.7 33.1 616.4 33.1 616.4 134.8 584.3 134.8 546.1 68.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": " Compound Path 2",
    className: "cls-1",
    d: "M380.4,95.3c-1.3-2.9-2.9-5.6-4.9-8-2.1-2.1-4.6-3.8-7.4-4.9-2.6-1.1-5.3-1.9-8-2.5,2.5-.5,5-1.4,7.4-2.5,2.3-1.1,4.4-2.5,6.2-4.3,1.9-1.8,3.2-4.2,3.7-6.8,1.2-2.5,1.2-5.5,1.2-8.6-.1-3.1-.5-6.2-1.2-9.2-1-3.1-3-5.9-5.5-8-2.7-2.7-6.1-4.6-9.9-5.5-5-1.3-10.2-2-15.4-1.9h-53.6v101.6h57.3c10.5,0,17.9-2.5,23.4-7.4s8-11.7,8-20.3c.5-3.9.1-7.9-1.3-11.7h0ZM319.4,49.7h27.1c2.1.1,4.2.5,6.2,1.2,1.6.4,3.1,1.3,4.3,2.5,1,1.1,1.9,2.3,2.5,3.7.6,1.4.8,2.8.6,4.3,0,3-1.1,5.8-3.1,8-1.9,2.5-5.5,3.1-10.5,3.1h-27.1v-22.8ZM360.1,113.2c-1.9,2.5-5.5,3.1-10.5,3.1h-30.2v-22.8h30.2c2.1.1,4.2.5,6.2,1.2,1.6.4,3.1,1.3,4.3,2.5,1,1.1,1.9,2.3,2.5,3.7.6,1.4.8,2.8.6,4.3,0,3-.6,6.1-3.1,8h0Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLbank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LBANK.f1a8627e5a44cb3a242c5e31b656992a.svg";